export default {
      id: "ic_solid_down_arrow-usage",
      viewBox: "0 0 11 6",
      url: "/" + "images/icons.3.109.2.svg#ic_solid_down_arrow-usage",
      toString: function () {
        return this.url;
      }
    }